import { PROJECT_ADMIN_TYPE } from 'lib/authorization/Roles'

type Badge =
  | {
      color: 'error' | 'primary'
      text: string
    }
  | undefined

export const getBadgeData = (
  blocked: boolean,
  status: string,
  type: string,
): Badge => {
  if (blocked) {
    return {
      color: 'error',
      text: 'blocked',
    }
  }

  if (status === 'active' && type === PROJECT_ADMIN_TYPE) {
    return {
      color: 'primary',
      text: 'admin',
    }
  }

  if (status === 'pending_activation') {
    return {
      color: 'primary',
      text: 'notFound',
    }
  }
}
